<template>
  <div class="error-page-holder content-layout-fixer">
    <div class="error-content-holder">
      <VueIcon
        class="icon"
        :iconName="iconWarn.name"
        :width="iconWarn.width"
        :height="iconWarn.height"
        iconColor="red"
      ></VueIcon>
      <VueText sizeLevel="12" weightLevel="5" class="content-header">Üzgünüz!</VueText>
      <VueText sizeLevel="12" class="content-message"
        >Sayfa<br />
        Bulunamamaktadır.</VueText
      >
      <div class="button-wrapper">
        <BrandButton @click="handleOnGoToButtonClick" :size="sizes.xLarge"
          >ANASAYFA'YA DÖN</BrandButton
        >
      </div>
    </div>
  </div>
</template>

<script>
import VueText from '@/components/shared/VueText/VueText.vue';
import VueIcon from '@/components/shared/VueIcon/VueIcon';
import BrandButton from '@/components/brand/BrandButton/BrandButton.vue';
import { ICON_VARIABLES, COMPONENT_SIZES } from '@/constants/component.constants.js';
import { mapGetters } from 'vuex';
import RoutesRoot from '@/router/routes/RoutesRoot';
import RoutesSecure from '@/router/routes/RoutesSecure';
import StorageHelper from '@/utils/storageHelper';

export default {
  name: 'NotFound',
  components: {
    VueText,
    VueIcon,
    BrandButton,
  },
  computed: {
    iconWarn() {
      return ICON_VARIABLES.warn;
    },
    sizes() {
      return COMPONENT_SIZES;
    },
    ...mapGetters('auth', ['isAuthenticated']),
  },
  methods: {
    handleOnGoToButtonClick() {
      const user = new StorageHelper({ id: process.env.VUE_APP_STORAGE_CURRENT_USER_KEY }).get();
      this.$router.push(
        this.isAuthenticated && !user.isImageRecognitionUser
          ? `${RoutesRoot.Secure.path}/${RoutesSecure.Feed.path}`
          : this.isAuthenticated && user.isImageRecognitionUser
          ? `${RoutesRoot.Secure.path}/${RoutesSecure.ImageRecognition.path}`
          : `${RoutesRoot.Home.path}`,
      );
    },
  },
};
</script>

<style scoped lang="scss">
.error-page-holder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  .error-content-holder {
    .icon {
      transform: scale(1.55);
      margin: palette-space-level('60') 0 palette-space-level('30');
    }

    .content-header {
      line-height: 1.2;
      margin-bottom: palette-space-level('10');
    }

    .content-message {
      margin-bottom: palette-space-level('40');
      line-height: 1.3;
    }
    .button-wrapper {
      margin: auto;
    }
  }
}
</style>
